var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mu-dialog',{attrs:{"title":"通知","width":"360","open":_vm.openSimple},on:{"update:open":function($event){_vm.openSimple=$event}}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('mu-button',{attrs:{"slot":"actions","flat":"","color":"primary"},on:{"click":_vm.closeSimpleDialog},slot:"actions"},[_vm._v("关闭")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }